<template>
  <div class="slideout_nav_container">

    <transition 
    name="" 
    mode="out-in"
    enter-active-class="animated slideInLeft faster" 
    leave-active-class="animated slideOutLeft faster" 
    >

    <nav id="mobile_nav"
    :class="$mq"
    v-if="show_mobile_nav"
    >

      <!-- CLOSE NAV BUTTON -->
      <div class="btn_close_nav"
      v-touch:tap="toggle_mobile_nav"
      >
        <font-awesome-icon icon="times"></font-awesome-icon>
      </div>
      
      <!-- NAV ITEMS -->
      <div class="nav_item_container container">
        <nav-mobile-item
        v-for="(item, index) in main_nav_items"
        :key="`nav_item_`+index"
        :label="item.label"
        :icon="item.icon"
        :path_name="item.path_name"
        ></nav-mobile-item>
      </div>

    </nav>

    </transition>

  </div>
  
</template>

<script>
import NavMobileItem from './nav_mobile_item.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faTimes
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faTimes
);

export default {
  name: 'nav_mobile',
  props: [
    
  ],
  data () {
    return {
      
    }
  },
  computed: {
    show_mobile_nav: function() {
      return this.$root.store.nav.get_mobile_nav_visibility();
    },
    main_nav_items: function() {
      return this.$root.store.nav.get_main_nav();
    }
  },
  methods: {
    toggle_mobile_nav: function() {
      // this.show_mobile_nav = !this.show_mobile_nav;
      this.$root.store.nav.toggle_mobile_nav();
    },
    request_close_nav: function() {
      this.$emit('request_close_nav', '');
    }
  },
  components: {
    NavMobileItem
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.slideout_nav_container {
  position: relative;
}

#mobile_nav {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-x: hidden;
  width: 85%;
  z-index: 1100;
  background: #FFF;
  border: solid 1px #ccc;
  box-shadow: 1px 1px 3px #777;
  padding: 1em;
  padding-left: 0em;
  padding-right: 0.2em;

  .btn_close_nav {
    position: absolute;
    right: 1em;
    top: 0.5em;
    font-size: 1.6em;
  }

  .nav_item_container {
    margin-top: 2.5rem;
  }

  &.desktop, &.laptop {
    width: 33%;
  }
}
</style>


// WEBPACK FOOTER //
// src/features/navigation/nav_mobile.vue